import gql from "graphql-tag";

export const MY_TIMESHEET_APPROVE_TIMESHEET = gql`
  mutation approveMysheetTimesheet($_id: String!, $message: String) {
    approveMysheetTimesheet(_id: $_id, message: $message)
  }
`;
